import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './ScrollableCard.module.css';

const ScrollableCardSkeleton = () => {
    const skeletonStyles = {
        backgroundColor: 'white',
        color: 'white', // Set the text color to white
      };
  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          className={`${index === 4 ? "" : "mr-4"} ${styles.scrollableImage}`}
          key={index}
        >
          <Skeleton variant="rectangular" width={120} height={120} sx={skeletonStyles} className='rounded-lg' />
          <Skeleton variant="text" width={60} sx={{ fontSize: '1rem', ...skeletonStyles }} />
          <Skeleton variant="text" width={60} sx={{ fontSize: '0.8rem', ...skeletonStyles }} />
        </div>
      ))}
    </>
  );
};

export default ScrollableCardSkeleton;
